import {$http,$util} from '@/lib'
import {Store,Module,ActionContext} from 'vuex' 


interface CurrentUserState{
    permissionList:string[];
    session:any;
    hasInit:boolean;
}
class CurrentUserStore implements Module<CurrentUserState,any>{
    namespaced=true;
    state={
        permissionList:[],
        session:{},
        hasInit:false
    }
    actions={
        async init(content:ActionContext<CurrentUserState,any>){
            let rep = await $http.get('TokenAuth/GetUserInfo');
            content.state.hasInit = true;
            content.state.session = rep.data.result.session;
            content.state.permissionList = rep.data.result.permissionList;
            $util.basic.auth.permissionList = rep.data.result.permissionList;
        },
        async changePassword(content:ActionContext<CurrentUserState,any>, payload:any){
            await $http.post('/services/app/User/ChangePassword', payload.data);
        },
    }
    mutations={
        setSession(state:CurrentUserState, session){
            state.hasInit = true;
            state.session = session;
        },

        setPermissionList(state:CurrentUserState, permissionList){
            state.permissionList = permissionList;
        }
    }
}
const currentUser=new CurrentUserStore();
export default currentUser;